import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Toaster } from "react-hot-toast";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./context/AuthContext";
import { SettingsProvider } from './context/SettingsContext';
import { LocationProvider } from './context/locationContext';
import { LanguageProvider } from './context/LanguageContext';

const queryClient = new QueryClient();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <LocationProvider>
          <SettingsProvider>
            <AuthProvider>
              <App />
              <Toaster />
            </AuthProvider>
          </SettingsProvider>
        </LocationProvider>
      </LanguageProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
